<template>
  <div class="content">
    <loading name="lp" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <base-header class="pb-6">
      <div class="row align-items-center py-0"></div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <base-button outline type="info" @click="onBack()">Back</base-button>
          <h3 class="mb-0">{{mode}} course</h3>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <tabs
            ref="tabs1"
            tabNavClasses="nav-fill flex-column flex-sm-row nav-wrapper"
            tabContentClasses="card shadow"
          >
            <tab-pane id="main">
              <span slot="title">Main</span>
              <validation-observer ref="formvalid">
                <div class="pl-lg-4">
                  <div class="row" v-if="mode === 'Edit'">
                    <div class="col-lg-12">
                      <base-input label="Status is active">
                        <base-switch
                          class="mr-1"
                          v-model="course.status"
                          type="success"
                          on-text="Yes"
                          off-text="No"
                        ></base-switch>
                      </base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        type="text"
                        rules="required"
                        label="Code"
                        placeholder="Code"
                        v-model="course.code"
                        name="Code"
                      ></base-input>
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        type="text"
                        label="Group code"
                        placeholder="Group code"
                        v-model="course.groupcode"
                        name="groupcode"
                      ></base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <base-input
                        type="text"
                        label="Title"
                        placeholder="Title"
                        v-model="course.title"
                        rules="required"
                        name="title"
                      ></base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <base-input label="Description" class="mr-1">
                        <textarea
                          class="form-control"
                          id="exampleFormControlTextarea3"
                          rows="3"
                          resize="none"
                          v-model="course.description"
                        ></textarea>
                      </base-input>
                    </div>
                  </div>
                </div>
              </validation-observer>
              <div class="pl-lg-4">
                <base-button block type="primary" @click.native="onSave">Save changes</base-button>
              </div>
            </tab-pane>

            <tab-pane id="stage" :disabled="!course.id">
              <span slot="title">Stages</span>
              <stages :courseId="courseId"></stages>
            </tab-pane>

            <tab-pane id="lesson" :disabled="!course.id">
              <span slot="title">Lessons</span>
              <lessons :courseId="courseId" @taskClicked="moveToTasks"></lessons>
            </tab-pane>

            <tab-pane id="task" title="task" :disabled="!course.id">
              <span slot="title">Tasks</span>
              <tasks ref="tasks"></tasks>
            </tab-pane>
          </tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetCourse, Create, Update } from "../../../services/courses";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { Tabs, TabPane } from "@/components";
import Loading from "vue-loading-overlay";
import { CourseType } from "../../../services/types";
import "vue-loading-overlay/dist/vue-loading.css";
import Stages from "./Stages";
import Lessons from "./Lessons";
import Tasks from "./Tasks";
export default {
  components: {
    Tabs,
    TabPane,
    Loading,
    RouteBreadCrumb,
    Stages,
    Lessons,
    Tasks,
  },
  props: {
    id: String,
    filter: String,
  },
  computed: {
    mode() {
      return this.courseId ? "Edit" : "Create";
    },
  },
  data() {
    return {
      isLoading: false,
      courseId: this.id,
      course: {},
      backfilter: this.filter,
    };
  },
  methods: {
    onBack() {
      this.$router
        .push({ path: "/courses/" + this.backfilter })
        .catch((e) => {});
    },
    onSave() {
      this.$refs.formvalid.validate().then((valid) => {
        if (valid) {
          this.isLoading = true;
          if (this.mode === "Create") {
            Create(this.course).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                this.courseId = response.data.result;
                this.course.id = response.data.result;
                this.notifyVue("success");
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          } else {
            Update(this.course).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                this.notifyVue("success");
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          }
        }
      });
    },
    moveToTasks(row) {
      this.$refs.tabs1.findAndActivateTab("task");
      this.$refs.tasks.lessonId = row.id;
      this.$refs.tasks.lessonName = row.title;
    },
  },
  created() {
    if (this.mode === "Create") {
      this.course = new CourseType();
    } else {
      this.isLoading = true;
      GetCourse(this.courseId).then((response) => {
        this.isLoading = false;
        if (response.data.result !== undefined) {
          this.course = response.data.result;
        } else {
          if (response.data) this.notifyVue("danger", response.data);
        }
      });
    }
  },
};
</script>
